import { MapUtils } from '../../utility/map-utils.js';
import { cloneData, isSameData } from '../dto/data-model-utils.js';

import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/data-model.js';
import { BusinessModuleRef } from './business-module-ref.js';

export class AlreadySentEvent extends DataModel {
  static readonly TYPE_ID: string = 'da5ead9125bd4036a12750a045b58954';

  private constructor(
    public readonly uniqueId: string,
    public readonly businessRef: BusinessModuleRef,
  ) {
    super();
  }

  get $typeId(): string {
    return AlreadySentEvent.TYPE_ID;
  }

  static create(args: {
    uniqueId: string,
    businessRef: BusinessModuleRef,
  }): AlreadySentEvent {
    return new AlreadySentEvent(
        args.uniqueId,
        args.businessRef,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): AlreadySentEvent {
    return AlreadySentEvent.create({
      uniqueId: MapUtils.getString(map, 'uniqueId'),
      businessRef: BusinessModuleRef.mustDecode(MapUtils.getString(map, 'businessRef')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'businessRef': this.businessRef.encode(),
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    uniqueId = this.uniqueId,
    businessRef = cloneData(this.businessRef),
  }: {
    uniqueId?: string,
    businessRef?: BusinessModuleRef,
  } = {}): this {
    return AlreadySentEvent.create({
      uniqueId,
      businessRef,
    }) as this;
  }

  isSame(other: AlreadySentEvent): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
      isSameData(other.businessRef, this.businessRef);
  }
}

export class AlreadySentEventBuilder extends DataModelBuilder<AlreadySentEvent> {
  build(context: SerializationContext, map: SerializedData): AlreadySentEvent {
    return AlreadySentEvent.fromMap(context, map);
  }
}
